// A trial may only be (re)started when backed by a server-issued token —
// otherwise trial_start is pure client-writable state, and clearing
// localStorage yields an unlimited free trial (the tokenless-trial bug).
// Single choke point: every mint of `${appId}_trial_start` routes through this.
export function canStartTrial(token) {
  return Boolean(token);
}
